module.exports = __webpack_public_path__ + "img/client1.ad6cb4f9.svg";